import { MgCannabis, MgCapsule, MgCartridge, MgDevice, MgEffervescent, MgInhaler, MgOralLiquid, MgPastille, MgPessary, MgPowder, MgResin, MgSpray, MgTablets, MgTopical, MgWafer, } from '@montugroup/icons';
import { ProductFormulations } from '../../types';
export const ProductFormulationsMap = {
    [ProductFormulations.HERB_DRIED]: {
        icon: MgCannabis,
        color: '#4F6B73',
        displayName: 'Flower',
    },
    [ProductFormulations.INHALATION]: {
        icon: MgCartridge,
        color: '#23AFFF',
        displayName: 'Inhalation',
    },
    [ProductFormulations.CAPSULE]: {
        icon: MgCapsule,
        color: '#EC407A',
        displayName: 'Capsule',
    },
    [ProductFormulations.ORAL_LIQUID]: {
        icon: MgOralLiquid,
        color: '#7986CB',
        displayName: 'Oral liquid',
    },
    [ProductFormulations.PASTILLE]: {
        icon: MgPastille,
        color: '#FFA726',
        displayName: 'Pastille',
    },
    [ProductFormulations.TABLET_CHEWABLE]: {
        icon: MgTablets,
        color: '#ba2cbf',
        displayName: 'Chewable tablet',
    },
    [ProductFormulations.DEVICE]: {
        icon: MgDevice,
        color: '#0074C4',
        displayName: 'Device',
    },
    [ProductFormulations.SPRAY]: {
        icon: MgSpray,
        color: '#406ac9', // todo real colour
        displayName: 'Spray',
    },
    [ProductFormulations.TOPICAL]: {
        icon: MgTopical,
        color: '#9E9D24', // todo real colour
        displayName: 'Topical',
    },
    [ProductFormulations.WAFER]: {
        icon: MgWafer,
        color: '#EF6C00', // todo real colour
        displayName: 'Wafer',
    },
    [ProductFormulations.CONCENTRATED_EXTRACT]: {
        icon: MgResin,
        color: '#4A148C',
        displayName: 'Concentrated Extract',
    },
    [ProductFormulations.INHALANT_PRESSURIZED]: {
        icon: MgInhaler,
        color: '#00897B',
        displayName: 'Inhalant (pressure)',
    },
    [ProductFormulations.POWDER]: {
        icon: MgPowder,
        color: '#AF7320',
        displayName: 'Powder',
    },
    [ProductFormulations.TABLET_EFFERVESCENT]: {
        icon: MgEffervescent,
        color: '#8A8F3A',
        displayName: 'Tablet, Effervescent',
    },
    [ProductFormulations.PESSARY]: {
        icon: MgPessary,
        color: '#C46B3C',
        displayName: 'Pessary',
    },
};
//# sourceMappingURL=data:application/json;base64,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